<template>
    <div class="choose_way">
        <div
            v-for="(item, index) in select"
            :key="item.type"
            :class="[item.class, { active: activeId == index }]"
            class="select_item"
            @click="exgActiveId(index, item.type)"
        >
            <div class="icon-div float_left">
                <i class="iconfont" :class="item.iconName"></i>
            </div>
            <div class="text-div float_left">
                <p>{{ item.title }}</p>
                <span class="fontsize-12">{{ item.describe }}</span>
            </div>
        </div>

        <el-button
            type="primary"
            round
            size="mini"
            style="width:240px; height:44px; margin:40px 0 60px 0;"
            @click="goNext"
            >下一步</el-button
        >
    </div>
</template>

<script>
export default {
    props: {
        activeWayId: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            select: [
                {
                    iconName: "icon-shouji",
                    class: "select-box",
                    title: "手机验证",
                    type: 1,
                    describe: "通过您注册的手机号码找回密码",
                    disabled: false,
                    isPrimary: true,
                },
                // {
                //     iconName: "icon-mail-copy",
                //     class: "select-box email",
                //     title: "邮箱验证",
                //     type: 2,
                //     describe: "通过您注册的邮箱账号找回密码",
                //     isPrimary: false,
                // },
            ],
            activeId: "",
        };
    },
    created() {
        this.activeId = this.activeWayId;
    },
    methods: {
        /**
         * 切换验证方式
         */
        exgActiveId(index, type) {
            this.activeId = index;
            this.$emit("next");
            this.$emit("setType", type);
        },
        /**
         * 下一步
         */
        goNext() {
            this.$emit("goNext", 1);
        },
    },
};
</script>
<style lang="scss">
.choose_way {
    .el-button--mini {
        width: 72px;
        height: 28px;
        line-height: 28px;
        padding: 0 !important;
        text-align: center;
        margin-bottom: 62px;
    }
}
</style>
<style lang="scss" scoped>
.choose_way {
    padding-top: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .float_left {
        float: left;
    }
    > div {
        border: 1px solid transparent;
        &.active {
            background: #fff;
            border-color: $primary;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
            .icon-div {
                background: rgba(64, 160, 130, 1);
            }
        }
    }
    .select_item {
        // border: 1px solid red;
        background-color: white;
    }

    .select-box {
        // width: calc(100%-100px);
        width: 750px;
        height: 110px;
        border-radius: 4px;
        // background: #f6f7f9;
        padding: 32px 56px 27px 56px;
        margin-bottom: 20px;
        margin-top: 72px;
        .icon-div,
        .but-div {
            width: 48px;
            height: 48px;
            line-height: 48px;
        }
        .icon-div {
            margin-right: 18px;
            padding: 0 11px;
            background: rgba(64, 160, 130, 0.5);
            border-radius: 4px;
            i {
                font-size: 26px;
                vertical-align: middle;
                color: #fff;
            }
        }
        .text-div {
            p {
                color: #000;
                font-size: 22px;
                margin-top: -5px;
                margin-bottom: 6px;
            }
            span {
                color: #666;
                font-size: 14px;
            }
        }
        .but-div {
            float: right;
        }
    }

    .email {
        margin-bottom: 20px;
    }

    .el-button:hover,
    .el-button:focus {
        background: #29b294;
        color: #fff;
        border-color: #29b294;
    }
}
</style>
